import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import LoginForm from "./LoginForm";
import { AppRoutes } from "../../routes/routeConstants/appRoutes";
import AuthContainer from "../../store/container/AuthContainer";
import {
  resolvePostLoginPath,
  storedLocationFromReturnUrlParam,
  StoredRedirectLocation,
} from "../../utils/postLoginRedirect";

function AuthRouter({
  authenticated,
}: {
  authenticated: boolean;
}) {
  const location = useLocation();

  if (authenticated) {
    const stateFrom = (location.state as { from?: StoredRedirectLocation } | undefined)?.from;
    const paramFrom = storedLocationFromReturnUrlParam(
      new URLSearchParams(location.search).get("returnUrl")
    );
    const to = resolvePostLoginPath(stateFrom ?? paramFrom, AppRoutes.HOME);
    return <Redirect to={to} />;
  }
  return (
    <Switch>
      <Redirect exact strict from={AppRoutes.AUTH} to={AppRoutes.LOGIN} />
      <Route exact path={AppRoutes.LOGIN} component={() => <LoginForm />} />
    </Switch>
  );
}

export default AuthContainer(AuthRouter);
